import MuiAccordionSummary, {
  AccordionSummaryProps
} from '@mui/material/AccordionSummary';

export interface IAccordionSummaryProps extends AccordionSummaryProps {}

const AccordionSummary = (props: IAccordionSummaryProps): JSX.Element => {
  return <MuiAccordionSummary {...props} />;
};

export default AccordionSummary;
